import { Checkbox } from '@mui/material';
import { DatagridClasses } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { TableBody, TableCell, TableHead, TableRow } from 'shared/mui/Table';

import { SkeletonStyled, TableStyled } from './DatagridSkeleton.styled';

export type DatagridSkeletonProps = {
  columnsCount: number;
  rowsCount?: number;
  hasBulkActions?: boolean;
};

export const DatagridSkeleton: React.FC<DatagridSkeletonProps> = ({
  columnsCount,
  rowsCount = 5,
  hasBulkActions = false,
}) => (
  <Box className={DatagridClasses.root}>
    <TableStyled>
      <TableHead>
        <TableRow>
          {hasBulkActions && (
            <TableCell padding="checkbox">
              <Checkbox checked={false} color="primary" />
            </TableCell>
          )}
          {Array.from({ length: columnsCount }).map((_, index) => (
            <TableCell key={index} variant="head">
              <SkeletonStyled height={21} variant="rectangular" />
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {Array.from({ length: rowsCount }).map((_, rowIndex) => (
          <TableRow key={rowIndex} sx={{ opacity: 1 / (rowIndex + 1) }}>
            {hasBulkActions && (
              <TableCell padding="checkbox">
                <Checkbox checked={false} color="primary" />
              </TableCell>
            )}
            {Array.from({ length: columnsCount }).map((_, cellIndex) => (
              <TableCell key={cellIndex}>
                <SkeletonStyled height={20} variant="rectangular" />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </TableStyled>
  </Box>
);
